import { render, staticRenderFns } from "./frigoMaintenance.vue?vue&type=template&id=49b89d41&scoped=true&"
import script from "./frigoMaintenance.vue?vue&type=script&lang=js&"
export * from "./frigoMaintenance.vue?vue&type=script&lang=js&"
import style0 from "./frigoMaintenance.vue?vue&type=style&index=0&id=49b89d41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b89d41",
  null
  
)

export default component.exports